import { deepFreeze } from '../tools/helpers';

import Accordion from './MD103_Akkordeon';
import BfvBildergalerieLightbox from './BfvBildergalerieLightbox';
import BfvBildergalerieSlider from './BfvBildergalerieSlider';
import BfvClubSearch from './BfvClubSearch';
import BfvCoachStations from './BfvCoachStations';
import BfvConditionalFormFields from './BfvConditionalFormFields';
import BfvDatepicker from './BfvDatepicker';
import BfvDropdown from './BfvDropdown';
import BfvEmailHandler from './BfvEmailHandler';
import BfvFavoriteController from './BfvFavoriteController';
import BfvSliderBar from './BfvSliderBar';
import BfvFavoritenDisplay from './BfvFavoritenDisplay';
import BfvFilteredLazyload from './BfvFilteredLazyload';
import BfvFontObfuscation from './BfvFontObfuscation';
import BfvSearchLazyload from './BfvSearchLazyload';
import BfvForm from './BfvForm';
import BfvFormular from './BfvFormular';
import BfvGalleryLightboxImage from './BfvGalleryLightboxImage';
import BfvMyAccountInputControl from './BfvMyAccountInputControl';
import BfvHeader from './BfvHeader';
import BfvImage from './BfvImage';
import BfvInfothekDownloads from '../infothek/downloads';
import BfvInfothekKontakte from '../infothek/kontakte';
import BfvInfothekNeuigkeiten from '../infothek/neuigkeiten';
import BfvInfothekPresse from '../infothek/presse';
import BfvLazyloadHtml from './BfvLazyloadHtml';
import BfvLazyLoadHtmlEvent from './BfvLazyLoadHtmlEvent';
import BfvLiveticker from './BfvLiveticker';
import BfvMultiselect from './BfvMultiselect';
import BfvNavigation from './BfvNavigation';
import BfvNavigationsSuche from './BfvNavigationsSuche';
import BfvNewsCompact from './BfvNewsCompact';
import BfvProfileStageLightbox from './BfvProfileStageLightbox';
import BfvScorer from './BfvScorer';
import BfvSearchresultProfiles from './BfvSearchresultProfiles';
import BfvSearchresults from './BfvSearchresults';
import BfvSpieltag from './BfvSpieltag';
import BfvStageNewsCompact from './BfvStageNewsCompact';
import BFVRadioBtnFormHandler from './BFVRadioBtnFormHandler';
import BfvWam from './BfvWam';
import Cookiehinweis from './MD117_Cookiehinweis';
import JumpNavigation from './JumpNavigation';
import SocialShareButtons from './SocialShareButtons';
import Switch from './Switch';
import TabNavigation from './MD115_Reitermodul';
import BfvInfothekTermine from '../infothek/termine';
import BfvEditProfile from './BfvEditProfile';
import BfvImageUpload from './BfvImageUpload';
import BfvInputHandler from './BfvInputHandler';
import BfvRepeatableList from './BfvRepeatableList';
import BfvEditProfileControls from './BfvEditProfileControls';
import BfvFileUpload from './BfvFileUpload';
import BfvVideoUpload from './BfvVideoUpload';
import BfvZipSearch from './BfvZipSearch';
import BfvIframeSizeHandler from './BfvIframeSizeHandler';


// module list for initialization
// noinspection JSUnusedGlobalSymbols
const moduleClasses = {
  Accordion,
  BfvBildergalerieLightbox,
  BfvBildergalerieSlider,
  BfvClubSearch,
  BfvCoachStations,
  BfvConditionalFormFields,
  BfvDatepicker,
  BfvDropdown,
  BfvEmailHandler,
  BfvFavoriteController,
  BfvFavoritenDisplay,
  BfvFilteredLazyload,
  BfvFontObfuscation,
  BfvSearchLazyload,
  BfvForm,
  BfvFormular,
  BfvGalleryLightboxImage,
  BfvMyAccountInputControl,
  BfvHeader,
  BfvImage,
  BfvInfothekNeuigkeiten,
  BfvInfothekDownloads,
  BfvInfothekPresse,
  BfvInfothekTermine,
  BfvInfothekKontakte,
  BfvLazyloadHtml,
  BfvLazyLoadHtmlEvent,
  BfvLiveticker,
  BfvMultiselect,
  BfvNavigation,
  BfvNavigationsSuche,
  BfvNewsCompact,
  BfvProfileStageLightbox,
  BfvScorer,
  BfvSearchresultProfiles,
  BfvSearchresults,
  BfvSpieltag,
  BfvSliderBar,
  BfvStageNewsCompact,
  BFVRadioBtnFormHandler,
  BfvWam,
  Cookiehinweis,
  JumpNavigation,
  SocialShareButtons,
  TabNavigation,
  BfvEditProfile,
  Switch,
  BfvImageUpload,
  BfvInputHandler,
  BfvRepeatableList,
  BfvEditProfileControls,
  BfvFileUpload,
  BfvVideoUpload,
  BfvZipSearch,
  BfvIframeSizeHandler,
};

deepFreeze(moduleClasses);

export default moduleClasses;
